import { BehaviorSubject, Observable } from 'rxjs';
import { isObservable } from 'rxjs';

export const toObservable = <T>(value: T | Observable<T>): Observable<T> => {
  if (isObservable(value)) {
    return value;
  }

  // If it's not an Observable already, convert it to one that will always
  // emit the value upon subscription
  return new BehaviorSubject(value);
};
